import { call, put, all, takeEvery, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";


import {
    // UPDATE_GPT_MODEL_MAIN_PAGE_NUMBER,
    GET_GPT_MODEL_MAIN_PENDING,
    GET_GPT_MODEL_MAINS,
    SG_GET_GPT_MODEL_MAINS,
    GET_GPT_MODEL_MAIN_SELECT,
    SG_GET_GPT_MODEL_MAIN_SELECT,
    DELETE_GPT_MODEL_MAIN,
    SG_DELETE_GPT_MODEL_MAIN,
    FETCH_GPT_MODEL_MAIN,
    SG_FETCH_GPT_MODEL_MAIN,
    EDIT_GPT_MODEL_MAIN,
    SG_EDIT_GPT_MODEL_MAIN,
    ADD_GPT_MODEL_MAIN,
    SG_ADD_GPT_MODEL_MAIN,
    // CLEAR_GPT_MODEL_MAIN,
    ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";


function* loadmethods(action) {
    yield put({ type: GET_GPT_MODEL_MAIN_PENDING });
  // console.log('action.payload', action.payload)
  try {
    const json = yield call(api.GET_GPT_MODEL_MAINS, action.payload);
    // console.log(json.data)
    yield put({ type: GET_GPT_MODEL_MAINS, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodLoad() {
  yield takeEvery(SG_GET_GPT_MODEL_MAINS, loadmethods);
}

function* loadSelectmethods(action) {
  yield put({ type: GET_GPT_MODEL_MAIN_PENDING });
// console.log('action.payload', action.payload)
try {
  const json = yield call(api.GET_GPT_MODEL_MAIN_SELECT, action.payload);
  // console.log(json.data)
  yield put({ type: GET_GPT_MODEL_MAIN_SELECT, payload: json.data });

} catch (e) {
  yield call(handleError, e);
}
}

export function* methodSelectLoad() {
yield takeEvery(SG_GET_GPT_MODEL_MAIN_SELECT, loadSelectmethods);
}

function* fetchmethods(action) {
    yield put({ type: GET_GPT_MODEL_MAIN_PENDING });
  try {
    const json = yield call(api.FETCH_GPT_MODEL_MAIN, action.payload);
    yield put({ type: FETCH_GPT_MODEL_MAIN, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodFetch() {
  yield takeLatest(SG_FETCH_GPT_MODEL_MAIN, fetchmethods);
}

function* updatemethods(action) {
  try {
    const json = yield call(api.EDIT_GPT_MODEL_MAIN, action.payload);
    yield put({ type: EDIT_GPT_MODEL_MAIN, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodUpdate() {
  yield takeLatest(SG_EDIT_GPT_MODEL_MAIN, updatemethods);
}

function* addmethods(action) {
  // RESET_ADD_ACTIVE_PAGE_GPT_MODEL_MAIN
  try {
    const json = yield call(api.ADD_GPT_MODEL_MAIN, action.payload);
    yield put({ type: ADD_GPT_MODEL_MAIN, payload: json.data });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodAdd() {
  yield takeLatest(SG_ADD_GPT_MODEL_MAIN, addmethods);
}

function* deletemethods(action) {
  try {
    yield call(api.DELETE_GPT_MODEL_MAIN, action.payload);
    yield put({ type: DELETE_GPT_MODEL_MAIN, payload: action.payload });

  } catch (e) {
    yield call(handleError, e);
  }
}

export function* methodDelete() {
  yield takeLatest(SG_DELETE_GPT_MODEL_MAIN, deletemethods);
}


export default function* index() {
  yield all([
    methodLoad(),
    methodSelectLoad(),
    methodFetch(),
    methodUpdate(),
    methodAdd(),
    methodDelete(),
  ]);
}
